

export const templateLayouts = [
    {text: 'Horizontal List', value: 'HLIST'},
    {text: 'Tabs', value: 'TABS'}
];

export const itemLayouts = [
  {
    text: "Table",
    value: "TABLE"
  },
  {
    text: "Line Charts",
    value: "LINE_CHART"
  },
  {
    text: "Pie Charts",
    value: "H_PIE_CHART"
  },
  {
    text: "Horizontal Bar Charts",
    value: "H_BAR_CHART"
  },
  {
    text: "Vertical Bar Charts",
    value: "V_BAR_CHART"
  },
  {
    text: "Frauds Map",
    value: "FRAUDS_MAP"
  }
];


export const columnTypes =  [
    {text: 'String', value: 'STRING'},
    {text: 'Numeric', value: 'NUMERIC'},
    {text: 'Boolean', value: 'BOOLEAN'},
    {text: 'List', value: 'SELECT'},
    {text: 'Date', value: 'DATE'},
];

export const columnTypeExtends =  [
    {text: 'String', value: 'STRING'},
    {text: 'Numeric', value: 'NUMERIC'},
    {text: 'Boolean', value: 'BOOLEAN'},
    {text: 'Date', value: 'DATE'},
];

export const allControlTypes =  [
    {text: 'Input Box', value: 'INPUT_BOX'},
    {text: 'Select Box', value: 'SELECT_BOX'},
    {text: 'Date Picker', value: 'DATE_PICKER'},
    {text: 'Date Range Picker', value: 'DATE_RANGE_PICKER'},
];

export const stringNumericControlTypes =  [
    {text: 'Input Box', value: 'INPUT_BOX'},
    {text: 'Select Box', value: 'SELECT_BOX'},
];

export const booleanControlTypes =  [
 ];

export const dateControlTypes =  [
    {text: 'Date Picker', value: 'DATE_PICKER'},
    {text: 'Date Range Picker', value: 'DATE_RANGE_PICKER'},
];

export const groupTypes =  [
    {text: 'Simple', value: 'SIMPLE'},
    {text: 'Query Builder', value: 'QUERY_BUILDER'},
];


export const stateTypes =  [
    {text: 'Active', value: true},
    {text: 'Inactive', value: false},
];

export const allStateTypes =  [
    {text: 'Active', value: true},
    {text: 'Inactive', value: false},
];

export const linkMethods =  [
    {text: 'GET', value: 'GET'},
    {text: 'POST', value: 'POST'},
];

export const allRuleTypes =  [
    {text: 'Real-Time', value: 1},
    {text: 'Batch', value: 2},
];

export const allDateRanges =  [
    {text: 'Yesterday', value: 'YESTERDAY'},
    {text: 'Today', value: 'TODAY'},
    {text: 'Last Week', value: 'LAST_WEEK'},
    {text: 'Last Month', value: 'LAST_MONTH'},
    {text: 'Last YEAR', value: 'LAST_YEAR'},
];

export const dateRanges =  [
    {text: 'Yesterday', value: 'YESTERDAY'},
    {text: 'Today', value: 'TODAY'},
    {text: 'Last Week', value: 'LAST_WEEK'},
    {text: 'Last Month', value: 'LAST_MONTH'},
    {text: 'Last YEAR', value: 'LAST_YEAR'},
];

export const optionTypes =  [
    {text: 'JSON', value: 'JSON'},
    {text: 'SQL', value: 'SQL'},
];


export const searchComponents =  [
    {text: 'Simple', value: 'SIMPLE'},
    {text: 'Table Inline', value: 'INLINE'},
    {text: 'Query Builder', value: 'QUERY_BUILDER'},
];


export const intervalCounts = [30,40,60,120,300];
export const rowCounts = [3,4,6,8,12];
export const colCounts = [3,4,6,8,12];
export const lgs = ['lg1', 'lg2','lg3','lg4','lg5','lg6','lg7','lg8','lg9','lg10','lg11','lg12'];
export const mds = ['md1', 'md2','md3','md4','md5','md6','md7','md8','md9','md10','md11','md12'];
export const sms = ['sm1', 'sm2','sm3','sm4','sm5','sm6','sm7','sm8','sm9','sm10','sm11','sm12'];
export const xss = ['xs1', 'xs2','xs3','xs4','xs5','xs6','xs7','xs8','xs9','xs10','xs11','xs12'];

export const allStatusValue =  [
    {text: 'Active', value: 1},
    {text: 'Inactive', value: 0},
];